import { useEffect } from 'react';
import { Auth } from '@aws-amplify/auth';
import { ApplicationAuthConfig } from '@tanium-cloud/tsp-contracts';
import { rewriteUrlOpenerFactory } from './urlOpener';

export const useCognito = ({ userPoolId, appClientId, region, domain }: ApplicationAuthConfig): void => {
  useEffect(() => {
    Auth.configure({
      region,
      userPoolId,
      userPoolWebClientId: appClientId,
      oauth: {
        domain,
        scope: ['email', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${window.location.origin}/`,
        redirectSignOut: `${window.location.origin}/`,
        responseType: 'code',
        urlOpener: rewriteUrlOpenerFactory(domain),
      },
      storage: window.sessionStorage,
    });
  }, [userPoolId, region, appClientId, domain]);
};
